export default __webpack_public_path__ + "static/media/logo-veloprime-horizontal-white.ea114eab.png";